<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.phoneNum" style="width: 150px;" size="mini" placeholder="手机号" clearable></el-input>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch" style="margin-left: 10px">搜索</el-button>
          <el-button type="primary" size="mini" style="margin-left: 10px" @click="bulkImport = true">批量导入</el-button>
          <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button>
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
          <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增</el-button>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            :checkbox-option="checkboxOption" row-key-field-name="phoneId" :cellSelectionOption="cellSelectionOption"
            style="width: 100%" :editOption="editOption" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 新增/编辑 -->
      <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑手机号' : '新增手机号'" :before-close="handleClose"
        :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
              <el-form-item label="手机号" prop="phoneNum">
                <el-input v-model="form.phoneNum" style="width: 80%;" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">确 定</el-button>
        </div>
      </el-drawer>
      <!-- 批量导入 -->
      <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
        style="margin-left: 200px;">
        <div style="margin: 0 10px 10px;display: flex;">
          <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
            :auto-upload="false" ref="bulk" multiple>
            <el-button size="medium" type="danger">点击上传</el-button>
          </el-upload>
          <div>
            <el-button type="primary"
              @click="downloadFile('https://equityapp.aojuai.com/file/equityfee/excel/ajefPhoneEightFive.xlsx', '手机号领取模板')"
              style="margin-left: 20%;height: 40px;">下载模板</el-button>
          </div>
        </div>
        <div>
          <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
            :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
            :cell-style-option="cellStyleOption" style="width: 100%" />
          <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getAjefPhoneEightFiveList, addAjefPhoneEightFive, updateAjefPhoneEightFive, deleteAjefPhoneEightFive, uploadAjefPhoneEightFive } from "../../api/api";
export default {
  name: "PhoneEightFive",
  data() {
    return {
      bulkImport: false,
      bulkData: [],
      columnsImport: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "phoneNum",
          key: "phoneNum",
          title: "手机号",
          align: "center",
        },
        {
          field: "status",
          key: "status",
          title: "状态",
          width: 150,
          align: "center",
        },
        {
          field: "statusMsg",
          key: "statusMsg",
          title: "状态备注",
          width: 150,
          align: "center",
        },
      ],
      // 弹窗与表单
      dialog: false,
      edit: false,
      form: {
        phoneNum: ''
      },
      rules: {
        phoneNum: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      // 表格相关
      tableLoading: false,
      totalCount: 100,
      tableHight: 520,
      tableData: [],
      key: 'phoneId',
      // 批量选中收集
      selectedRowKeysCollection: [],
      checkboxOption: {
        selectedRowKeys: [],
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected, this.key);
        },
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys, this.key);
        },
      },
      cellSelectionOption: { enable: true },
      editOption: {},
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      // 查询与分页参数
      formDatas: {
        phoneNum: '',
        currentPage: 1,
        pageSize: 10
      },
      // 表格列定义
      columns: [
        {
          field: "",
          key: "checkbox",
          type: "checkbox",
          title: "",
          width: 50,
          align: "center",
        },
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "phoneNum",
          key: "phoneNum",
          title: "手机号",
          align: "center",
        },
        {
          field: "createusername",
          key: "createusername",
          title: "创建人",
          align: "center",
        },
        {
          field: "createtime",
          key: "createtime",
          title: "创建时间",
          align: "center",
        },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 150,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                <el-button type="text" size="mini" on-click={() => this.editorgan(row)}>
                  编辑
                </el-button>
                <el-button type="text" size="mini" style="color: #F56C6C" on-click={() => this.deleteRow(row)}>
                  删除
                </el-button>
              </div>
            );
          },
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      this.tableLoading = true;
      getAjefPhoneEightFiveList(this.formDatas).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 搜索
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    // 翻页
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    // 新增弹窗
    BoxOpen() {
      this.edit = false;
      this.form = { phoneNum: '' };
      this.dialog = true;
    },
    // 编辑回填
    editorgan(row) {
      this.edit = true;
      this.form = {
        phoneId: row.phoneId,
        phoneNum: row.phoneNum,
      };
      this.dialog = true;
    },
    // 关闭抽屉
    handleClose() {
      this.dialog = false;
    },
    // 提交新增/编辑
    SureBtn() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const title = this.edit ? '确认编辑该手机号？' : '确认新增该手机号？';
          this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (this.edit) {
              updateAjefPhoneEightFive(this.form).then((res) => {
                this.$message.success('编辑成功');
                this.handleClose();
                this.getList();
              }).catch(() => {
                this.$message.error('编辑失败');
              });
            } else {
              addAjefPhoneEightFive(this.form).then((res) => {
                this.$message.success('新增成功');
                this.handleClose();
                this.getList();
              }).catch(() => {
                this.$message.error('新增失败');
              });
            }
          });
        }
      });
    },
    // 单条删除
    deleteRow(row) {
      this.$confirm('确认删除该手机号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAjefPhoneEightFive({ phoneIds: row.phoneId }).then((res) => {
          this.$message.success('删除成功');
          this.getList();
        }).catch(() => {
          this.$message.error('删除失败');
        });
      });
    },
    // 批量删除
    BulkDelete() {
      if (this.selectedRowKeysCollection.length == 0) {
        this.$message.warning('请先勾选要删除的记录');
        return;
      }
      this.$confirm(`确认删除选中的 ${this.selectedRowKeysCollection.length} 条记录？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAjefPhoneEightFive({ phoneIds: this.selectedRowKeysCollection.toString() }).then((res) => {
          this.$message.success('批量删除成功');
          this.checkboxOption.selectedRowKeys = [];
          this.selectedRowKeysCollection = [];
          this.getList();
        }).catch(() => {
          this.$message.error('批量删除失败');
        });
      }).catch(() => {
        this.$message.info('已取消');
      });
    },
    // checkbox 单选
    changeSelectedRowKeys(row, isSelected, key) {
      const rowKey = row[key];
      if (isSelected) {
        this.checkboxOption.selectedRowKeys.push(rowKey);
        this.selectedRowKeysCollection.push(rowKey);
      } else {
        const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
        this.checkboxOption.selectedRowKeys.splice(index, 1);
        const colIndex = this.selectedRowKeysCollection.indexOf(rowKey);
        if (colIndex > -1) {
          this.selectedRowKeysCollection.splice(colIndex, 1);
        }
      }
    },
    // checkbox 全选
    changeSelectAll(isSelected, selectedRowKeys, key) {
      this.checkboxOption.selectedRowKeys = selectedRowKeys;
      if (isSelected) {
        this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
      } else {
        this.tableData.forEach((item) => {
          const idx = this.selectedRowKeysCollection.indexOf(item[key]);
          if (idx > -1) {
            this.selectedRowKeysCollection.splice(idx, 1);
          }
        });
      }
    },
    // 批量导入-选择文件后立即上传
    updatabulk(file, fileList) {
      let Data = new FormData();
      Data.append('file', file.raw);
      this.openLoading();
      uploadAjefPhoneEightFive(Data).then(res => {
        this.loadings.close();
        this.bulkData = res.data.data;
      });
    },
    // 关闭导入弹窗
    bulkImportClose(done) {
      done();
      this.bulkData = [];
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 下载模板文件
    downloadFile(url, name) {
      if (!url) return;
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.onload = function () {
        document.body.removeChild(link);
      };
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // loading
    openLoading() {
      this.loadings = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
  },
};
</script>

<style scoped>
</style>
